<button uiButton type="button" (click)="open()">Open safe-action dialog</button>
<p role="status">{{ result() }}</p>
